import { secondsToHms } from "@evercam/shared/utils"

export default [
  {
    value: "delete",
    text: "",
    width: "2%",
    sortable: false,
    align: "center",
  },
  {
    value: "progress",
    text: "",
    width: "2%",
    sortable: false,
    align: "center",
  },
  {
    value: "id",
    text: "ID",
    width: "5%",
    sortable: false,
    align: "center",
  },
  {
    value: "fromDate",
    text: "From Date",
    width: "10%",
    sortable: false,
  },
  {
    value: "toDate",
    text: "To Date",
    width: "10%",
    sortable: false,
  },
  {
    value: "injectToCr",
    text: "Inject to CR",
    width: "5%",
    sortable: false,
    align: "center",
  },
  {
    value: "jpegsToDropbox",
    text: "JPEGs to DropBox",
    width: "10%",
    sortable: false,
    align: "center",
  },
  {
    value: "interval",
    text: "Interval",
    width: "10%",
    align: "center",
    sortable: false,
    toStringFn: (item, key) => secondsToHms(item[key]),
  },
  {
    value: "status",
    text: "Status",
    width: "5%",
    sortable: false,
    align: "center",
  },
  {
    value: "type",
    text: "Type",
    width: "3%",
    align: "center",
    sortable: false,
  },
  {
    value: "requestor",
    text: "Requestor",
    width: "10%",
    sortable: false,
  },
  {
    value: "createdAt",
    text: "Created At",
    width: "10%",
    sortable: false,
  },
]
